<template>
  <div class="login">
    <div class="welcome">
      <h1 style="color: #ffffff; text-align: center">账号注册/修改</h1>
    </div>
    <div class="login-form">
      <el-form ref="user" :model="user" :rules="rules">
        <el-form-item class="login-inp" prop="cardid">
          <el-input v-model="user.cardid" placeholder="请输入卡号"></el-input>
        </el-form-item>
        <el-form-item class="login-inp" prop="username">
          <el-input v-model="user.username" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item class="login-inp" prop="password">
          <el-input
            type="password"
            v-model="user.password"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item class="login-inp" prop="password2">
          <el-input
            type="password"
            v-model="user.password2"
            placeholder="请确认密码"
          ></el-input>
        </el-form-item>
        <el-form-item class="login-inp">
          <el-button style="width: 100%" type="primary" @click="check"
            >注册</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value.length < 5) {
        callback(new Error("密码不能小于5位!"));
      } else if (value.length > 18) {
        callback(new Error("密码不能大于18位!"));
      } else {
        if (this.user.password2 !== "") {
          this.$refs.user.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.user.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validateCardid = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入卡号"));
      } else if (value.length < 5) {
        callback(new Error("卡号不能小于5位!"));
      } else if (value.length > 18) {
        callback(new Error("卡号不能大于18位!"));
      } else {
        callback();
      }
    };
    var validateUsername = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入账号"));
      } else if (value.length < 2) {
        callback(new Error("账号不能小于2位!"));
      } else if (value.length > 18) {
        callback(new Error("账号不能大于18位!"));
      } else {
        callback();
      }
    };
    return {
      user: {
        cardid: "",
        username: "",
        password: "",
        password2: "",
        oldPassword: "",
      },
      rules: {
        password: [{ validator: validatePass, trigger: "blur" }],
        password2: [{ validator: validatePass2, trigger: "blur" }],
        cardid: [{ validator: validateCardid, trigger: "blur" }],
        username: [{ validator: validateUsername, trigger: "blur" }],
      },
    };
  },
  methods: {
    register() {
      const loading = this.$loading();
      var that = this;
      if (this.user.oldPassword) {
        this.user.oldPassword = that.GLOBAL.aesEncrypt(this.user.oldPassword);
      }

      this.axios
        .post("/User/UserRegister", {
          account: this.user.username,
          password: that.GLOBAL.aesEncrypt(this.user.password),
          cardid: this.user.cardid,
          oldPassword: this.user.oldPassword,
        })
        .then(function (response) {
          if (response.status == 200) {
            if (response.data.state == 0) {
              that.$message.success("注册/修改账号成功");
              that.$router.push("/login");
            } else {
              that.$message.error(response.data.message);
            }
          } else {
            that.$message.error("请检查网络设置");
          }
          loading.close();
        });

    },
    check() {
      this.$refs["user"].validate((valid) => {
        if (valid) {
          console.log(this.user);
          const loading = this.$loading();
          var that = this;
          this.axios
            .post("/User/CheckUserPwd", { cardid: this.user.cardid })
            .then(function (response) {
              if (response.status == 200) {
                if (response.data.state == -1) {
                  that.confirm();
                } else if (response.data.state == 0) {
                  that.register();
                } else {
                  that.$message.error(response.data.message);
                }
              } else {
                that.$message.error("请检查网络设置");
              }
            });
          loading.close();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    confirm() {
      var that = this;
      const h = this.$createElement;
      this.$msgbox({
        title:
          "此卡已注册，请输入原密码进行修改，如果忘记密码请联系你们公司的管理清除密码。",
        message: h("input", {
          attrs: {
            id: "oldPassword",
            class: "confirm",
            type: "password",
          },
          value: that.user.oldPassword,
          on: { input: this.onOldPwdInputChange }
        }),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            that.register();
          } else {
            done();
          }
        },
      }).then((action) => {
        this.$message({
          type: "info",
          message: "message",
        });
      });
    },
    onOldPwdInputChange() {
      this.user.oldPassword = document.getElementById("oldPassword").value;
    }
  },
};
</script>

<style scoped>
.login {
  width: 100%;
  height: 100%;
  background: url(../../assets/bg.png) no-repeat;
  background-size: cover;
  position: fixed;
  z-index: -10;
}
.welcome {
  width: 100%;
  margin: 25% 0;
}
.welcome img {
  width: 100%;
}
.login-inp {
  margin: 0 30px 25px 30px;
  border-radius: 25px;
}

.confirm {
  outline-style: none;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 3px 4px;
  width: 70%;
  font-size: 14px;
  font-family: "Microsoft soft";
}
.confirm:focus {
  border-color: #66afe9;
  outline: 0;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(102, 175, 233, 0.6);
}
</style>


// WEBPACK FOOTER //
// src/components/Register/Index.vue